import React, { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Extend Window interface to include GSAP plugins
declare global {
  interface Window {
    ScrollTrigger: any;
    ScrollSmoother: any;
  }
}

const LoadScript = () => {
  const location = useLocation();

  // 1. Disable browser's automatic scroll restoration on first load
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  const loadMainScript = () => {
    const scriptId = 'main-js-script';

    // Kill existing instances
    if (window.ScrollTrigger) {
      window.ScrollTrigger.killAll();
    }
    if (window.ScrollSmoother && window.ScrollSmoother.get()) {
      window.ScrollSmoother.get().kill();
    }

    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      document.body.removeChild(existingScript);
    }

    const script = document.createElement('script');
    script.src = '/assets/js/main.js';
    script.defer = true;
    script.id = scriptId;
    script.onload = () => {
      // Refresh triggers once the main script is definitely loaded
      if (window.ScrollTrigger) {
        window.ScrollTrigger.refresh();
      }
    };
    document.body.appendChild(script);
  };

  // 2. High-priority scroll reset the millisecond the URL changes
  useLayoutEffect(() => {
    // Immediate reset
    window.scrollTo(0, 0);

    // Reset via requestAnimationFrame for browser sync
    const rafId = requestAnimationFrame(() => {
      window.scrollTo(0, 0);
      const smoother = window.ScrollSmoother && window.ScrollSmoother.get();
      if (smoother) {
        smoother.scrollTop(0);
      }
    });

    // Refresh triggers to prevent height mismatch
    if (window.ScrollTrigger) {
      window.ScrollTrigger.refresh();
    }

    // 3. Re-initialize the smoothing engine for the new page layout
    const timeoutId = setTimeout(() => {
      loadMainScript();

      // Secondary safety reset after script loads
      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
      });
    }, 50);

    return () => {
      cancelAnimationFrame(rafId);
      clearTimeout(timeoutId);
    };
  }, [location.pathname]);

  return <></>;
};

export default LoadScript;
